
export default class {

  constructor(delay, callback) {
    this.timer = null
    this.defaultDelay = delay
    this.callbackMethod = callback
  }

  start = (delay) => {
    if (delay == null) delay = this.defaultDelay
    this.cancel()
    this.timer = setInterval(() => { this.callback() }, delay)		// note: callback could change
  }

  check = () => {
    if (this.timer == null) this.timer = setInterval(() => { this.callback() }, this.defaultDelay)	// note: callback could change
  }

  fire = (delay) => {
    if (delay == null) delay = this.defaultDelay
    this.cancel()
    this.timer = setInterval(() => {
      this.callback()
      this.cancel()
    }, delay)
  }

  trigger = () => {
    this.callback()
    this.cancel()
  }

  cancel = () => {
    if (this.timer != null) clearInterval(this.timer)
    this.timer = null
  }

  restart = (_callback, delay) => {
    this.cancel()
    if (delay == null) delay = this.defaultDelay
    this.callback = _callback
    this.start(delay)
  }

  refire = (_callback, delay) => {
    this.cancel()
    if (delay == null) delay = this.defaultDelay
    this.callback = _callback
    this.fire(delay)
  }

  callback = () => {
    try {
      this.callbackMethod()
    } catch (e) {
      console.error(e)
    }
  }

  setCallback = (cb) => { this.callbackMethod = cb }

  isRunning = () => this.timer != null
}
